/*Stickerify text*/

const stickers = {
    ":baby-confused:" : "https://assets.parenttown.com/stickers/12.png",
    ":baby-grin:" : "https://assets.parenttown.com/stickers/17.png",
    ":baby-hearteyes:" : "https://assets.parenttown.com/stickers/07.png",
    ":baby-hi:" : "https://assets.parenttown.com/stickers/01.png",
    ":baby-sad:" : "https://assets.parenttown.com/stickers/03.png",
    ":boy-angel:" : "https://assets.parenttown.com/stickers/21.png",
    ":boy-angry:" : "https://assets.parenttown.com/stickers/10.png",
    ":boy-blush:" : "https://assets.parenttown.com/stickers/02.png",
    ":boy-cool:" : "https://assets.parenttown.com/stickers/08.png",
    ":boy-crown:" : "https://assets.parenttown.com/stickers/19.png",
    ":boy-crying:" : "https://assets.parenttown.com/stickers/04.png",
    ":boy-exicted:" : "https://assets.parenttown.com/stickers/16.png",
    ":boy-happy:" : "https://assets.parenttown.com/stickers/05.png",
    ":boy-pissed:" : "https://assets.parenttown.com/stickers/09.png",
    ":boy-sad-crying:" : "https://assets.parenttown.com/stickers/14.png",
    ":boy-sleeping:" : "https://assets.parenttown.com/stickers/11.png",
    ":boy-wink:" : "https://assets.parenttown.com/stickers/18.png",
    ":boy-wow:" : "https://assets.parenttown.com/stickers/13.png",
    ":cancel:" : "https://assets.parenttown.com/stickers/30.png",
    ":girl-blush:" : "https://assets.parenttown.com/stickers/15.png",
    ":girl-crown:" : "https://assets.parenttown.com/stickers/20.png",
    ":girl-kiss:" : "https://assets.parenttown.com/stickers/06.png",
    ":lol:" : "https://assets.parenttown.com/stickers/23.png",
    ":omg:" : "https://assets.parenttown.com/stickers/24.png",
    ":parenttown:" : "https://assets.parenttown.com/stickers/28.png",
    ":so-cute:" : "https://assets.parenttown.com/stickers/22.png",
    ":tap:" : "https://assets.parenttown.com/stickers/27.png",
    ":thank-you:" : "https://assets.parenttown.com/stickers/25.png",
    ":thumbs-up:" : "https://assets.parenttown.com/stickers/26.png",
    ":tick:" : "https://assets.parenttown.com/stickers/29.png"
};

const Stickerify = (contentStr) => {
    const pattern = /:(.+?):/g 
    const workload = {};
    try {
        //match
        let subMatches;
        while((subMatches = pattern.exec(contentStr))!== null){
            workload[subMatches[0]] = "";
        }
        //return if empty
        let isEmpty = true;
        if(Object.keys(workload).length) isEmpty = false;
        if(isEmpty) return contentStr;
        //replace
        for(const rawType in workload){
            contentStr = contentStr.replace(new RegExp(rawType, "g"), substituteSticker(rawType));
        }
    } catch(err){
        console.log(err);
        return contentStr;
    }
    return contentStr;
}

const substituteSticker = (rawType) => {
    let retString = rawType;
    if(rawType in stickers) {
        retString = `<img src="${stickers[rawType]}" alt="Stickerify"/>`;
    }
    return retString;
}

export default Stickerify;

